export default __webpack_public_path__ + "static/pexels-anete-lusina-5240643-e095400b9b7e73b2c0d5b98c9fa61613.jpg";